import { jsx as _jsx } from "react/jsx-runtime";
import merge from 'lodash/merge';
import { createContext } from 'react';
import { tokens } from '../../constants';
var StateConfigContext = createContext({
  theme: 'light',
  tokens
});
var StateConfigProvider = props => {
  var config = props.config;
  return _jsx(StateConfigContext.Provider, Object.assign({
    value: merge({
      theme: 'light',
      tokens
    }, config)
  }, {
    children: props.children
  }));
};
export { StateConfigContext, StateConfigProvider };